module.exports = __webpack_public_path__ + "img/gggl3.e758067a.png";